import { render, staticRenderFns } from "./TableBook.vue?vue&type=template&id=65672e25&scoped=true"
import script from "./TableBook.vue?vue&type=script&lang=js"
export * from "./TableBook.vue?vue&type=script&lang=js"
import style0 from "./TableBook.vue?vue&type=style&index=0&id=65672e25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65672e25",
  null
  
)

export default component.exports